<template>

    <bottom-sheet ref="bottomsheet">

        <div class="mailbox">

            <img src="/img/bottomsheet/img-push.svg" class="img__72">

            <h2 class="title-lBold mt__32">{{ $t('fetch_add_inbox_title') }}</h2>

            <p class="text-lRegular mt__16">{{ $t('fetch_add_inbox_desc') }}</p>

            <button class="add text-lSemibold color__white" @click="add">{{ $t('fetch_add_mailbox_cta') }}</button>

            <button class="close text-lSemibold" @click="clickClose">{{ $t('fetch_add_inbox_cta_no') }}</button>

        </div>

    </bottom-sheet>

</template>

<script>
import Vuex from 'vuex'

import Tag from '@/modules/tag'

import BottomSheet from '@/components/bottomSheet/BottomSheet'

export default {

    name: 'bottom-sheet-add-maibox',

    components: {BottomSheet},

    watch: {
        showBottomSheetAddMailbox: function (bool) {
            bool
                ? this.open()
                : this.close()
        }
    },

    computed: {
        ...Vuex.mapState({
            showBottomSheetAddMailbox: state => state.showBottomSheetAddMailbox
        })
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
            Tag.pageViewGA(this, 'fetch_add_inbox')
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        add() {
            Tag.clickGA(this, 'add_inbox')
            this.$router.push({path: '/add-inbox'})
        },

        clickClose() {
            Tag.clickGA(this, 'no')
            this.close()
        }
    }

}

</script>

<style lang="scss" scoped>

.mailbox {
    padding: 46px 24px 109px;
    width: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-image: url("/img/bottomsheet/illustration-footer.svg");
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
    background-size: contain;

    .add {
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px 40px;
        border-radius: 32px;
        background-color: $aquamarine;
    }

    .close {
        margin-top: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 36px;
        border-radius: 64px;
        border: solid 4px #e7e7e8;
        background-color: $white;
    }
}

</style>
